import { TabsProps as AntdTabsProps, Tabs as AntdTabs } from "antd";
import React from "react";

export type TabsProps = AntdTabsProps;

const Tabs = (props: TabsProps) => {
  return <AntdTabs {...props} />;
};

export default Tabs;

Tabs.TabPane = AntdTabs.TabPane;
